export const lookupsConstant = {
    GET_MANAGERS_LOOKUPS_SUCCESS : "GET_MANAGERS_LOOKUPS_SUCCESS",
    GET_MANAGERS_LOOKUPS_FAILURE : "GET_MANAGERS_LOOKUPS_FAILURE",

    GET_STATUS_LOOKUP_SUCCESS : "GET_STATUS_LOOKUP_SUCCESS",
    GET_STATUS_LOOKUP_FAILURE : "GET_STATUS_LOOKUP_FAILURE",

    GET_USERS_LOOKUP_DATA_SUCCESS : "GET_USERS_LOOKUP_DATA_SUCCESS",
    GET_USERS_LOOKUP_DATA_FAILURE : "GET_USERS_LOOKUP_DATA_FAILURE",

    COMMNETS_TYPES_LOOKUP_DATA_SUCCESS : "COMMNETS_TYPES_LOOKUP_DATA_SUCCESS",
    COMMNETS_TYPES_LOOKUP_DATA_FAILURE : "COMMNETS_TYPES_LOOKUP_DATA_FAILURE",

    GET_DEPARTMENT_LOOKUP_SUCCESS : "GET_DEPARTMENT_LOOKUP_SUCCESS",
    GET_DEPARTMENT_LOOKUP_FAILURE : "GET_DEPARTMENT_LOOKUP_FAILURE",

    GET_TEAM_LOOKUP_SUCCESS : "GET_TEAM_LOOKUP_SUCCESS",
    GET_TEAM_LOOKUP_FAILURE : "GET_TEAM_LOOKUP_FAILURE",

    GET_LOCATION_LOOKUP_SUCCESS : "GET_LOCATION_LOOKUP_SUCCESS",
    GET_LOCATION_LOOKUP_FAILURE : "GET_LOCATION_LOOKUP_FAILURE",

    GET_JOBTITLE_LOOKUP_SUCCESS : "GET_JOBTITLE_LOOKUP_SUCCESS",
    GET_JOBTITLE_LOOKUP_FAILURE : "GET_JOBTITLE_LOOKUP_FAILURE",

    GET_EMPLOYEETYPE_SUCCESS : "GET_EMPLOYEETYPE_SUCCESS",
    GET_EMPLOYEETYPE_FAILURE : "GET_EMPLOYEETYPE_FAILURE",

    GET_TRAININGTYPE_SUCCESS : "GET_TRAININGTYPE_SUCCESS",
    GET_TRAININGTYPE_FAILURE : "GET_TRAININGTYPE_FAILURE",

    GET_TRAININGLEVEL_SUCCESS : "GET_TRAININGLEVEL_SUCCESS",
    GET_TRAININGLEVEL_FAILURE : "GET_TRAININGLEVEL_FAILURE",

    GET_TRAININGSTATUS_SUCCESS : "GET_TRAININGSTATUS_SUCCESS",
    GET_TRAININGSTATUS_FAILURE : "GET_TRAININGSTATUS_FAILURE",

    GET_EMP_TRAINING_STATUS_SUCCESS : "GET_EMP_TRAINING_STATUS_SUCCESS",
    GET_EMP_TRAINING_STATUS_FAILURE : "GET_EMP_TRAINING_STATUS_FAILURE",

    GET_EMPLOYEELEVEL_SUCCESS : "GET_EMPLOYEELEVEL_SUCCESS",
    GET_EMPLOYEELEVEL_FAILURE : "GET_EMPLOYEELEVEL_FAILURE",

    GET_YESNO_SUCCESS : "GET_YESNO_SUCCESS",
    GET_YESNO_FAILURE : "GET_YESNO_FAILURE",

    GET_ONLY_REPORTING_USERS_SUCCESS: "GET_ONLY_REPORTING_USERS_SUCCESS",
    GET_ONLY_REPORTING_USERS_FAILURE: "GET_ONLY_REPORTING_USERS_FAILURE"
}